import { env } from "./variable-config";

const makePlaceholder = codePoints => String.fromCharCode(...codePoints);

const versionInfoPlaceholder = makePlaceholder([
  91,
  91,
  118,
  101,
  114,
  115,
  105,
  111,
  110,
  73,
  110,
  102,
  111,
  93,
  93
]);
const versionDatePlaceholder = makePlaceholder([
  91,
  91,
  118,
  101,
  114,
  115,
  105,
  111,
  110,
  68,
  97,
  116,
  101,
  93,
  93
]);

const envLabelMap = {
  local: "local",
  dev: "dev",
  test: "test",
  prod: "production"
};

const isPlaceholder = (value, placeholder) =>
  typeof value !== "string" || value.includes(placeholder);

const resolveEnvLabel = currentEnv => envLabelMap[currentEnv] || currentEnv;

export const getVersionInfoText = (value = versionInfoPlaceholder) => {
  if (!isPlaceholder(value, versionInfoPlaceholder)) return value;
  if (env === "local") return "myCareBase local dev — hot reload";
  return `myCareBase ${resolveEnvLabel(env)} build pending`;
};

export const getVersionDateText = (value = versionDatePlaceholder) => {
  if (!isPlaceholder(value, versionDatePlaceholder)) return value;
  if (env === "local") return "Hot reload development session";
  return "";
};
